import { GET_SEARCH_RESULTS } from '../actions';

export default (state = [], action) => {
  switch (action.type) {
    case GET_SEARCH_RESULTS:
      return action.payload;
    // break;
    default:
      return state;
    // break;
  }
};
